import React from 'react';
import styled from '@emotion/styled';
import DocumentTypes from '../components/DocumentTypes';

const PageContainer = styled.div`
  background: white;
  border-radius: 8px;
  padding: 2rem;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
`;

const Title = styled.h1`
  color: #333;
  margin-bottom: 2rem;
  font-size: 2rem;
  font-weight: 600;
`;

function Settings() {
  return (
    <PageContainer>
      <Title>Settings</Title>
      <DocumentTypes />
    </PageContainer>
  );
}

export default Settings;
